class List {
  constructor (name) {
    this.name = name
    this.active = true
    this.id = ~~(Math.random() * 1000000)
  }
}

export default {
  state: {
    lists: [{
      name: 'Reminders',
      id: 111,
      active: true
    },
    {
      name: 'Difficult tasks',
      id: 222,
      active: false
    },
    {
      name: 'Study',
      id: 333,
      active: false
    },
    {
      name: 'For work',
      id: 444,
      active: false
    }
    ]
  },
  mutations: {
    deleteList (state, payload) {
      state.lists = state.lists.filter(elem => {
        return elem.id !== payload
      })
    },
    changeActive (state, payload) {
      state.lists.forEach(elem => {
        if (elem.id === payload) elem.active = !elem.active
      })
    },
    makeActiveFirst (state) {
      state.lists.find(elem => {
        elem.active = !elem.active
        return true
      })
    },
    addList (state, payload) {
      state.lists.push(payload)
    },
    loadLists (state, payload) {
      state.lists = payload
    }
  },
  actions: {
    deleteList ({commit, dispatch}, payload) {
      commit('deleteList', payload)
      dispatch('uploadListsToLocalStorage')
    },
    changeList ({commit, getters, dispatch}, payload) {
      let active = getters.active
      commit('changeActive', active.id)
      commit('changeActive', payload.id)
      dispatch('uploadListsToLocalStorage')
    },
    createList ({commit, getters, dispatch}, payload) {
      commit('changeActive', getters.active.id)
      let list = new List(payload)
      commit('addList', list)
      dispatch('uploadListsToLocalStorage')
    },
    makeActiveFirst ({commit, dispatch}) {
      commit('makeActiveFirst')
      dispatch('uploadListsToLocalStorage')
    }
  },
  getters: {
    lists (state) {
      return state.lists
    },
    active (state) {
      return state.lists.find(elem => !!elem.active)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/lists.js